<template>
  <div>
    <div class="row">
      <div class="col-md-11">
        <b-button variant="link" class="p-0" pill @click="addNewPremium"
                  :class="{'mb-3': model.premiums && model.premiums.length > 0}">
          <font-awesome-icon :icon="'plus-circle'"/>
          {{ $t('New Premium Tier') }}
        </b-button>
      </div>
    </div>
    <div class="row" v-for="(premium, index) in model.premiums" :key="premium.uuid">
      <div class="col-md-11">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col" style="flex: 1">
                {{ $t('Percentage') }}
                <span class="text-danger">*</span>
              </div>
              <div class="col" style="flex: 1">
                <percentage-input-widget :label="false" :model="premium" attribute="percent" step="any"/>
              </div>
            </div>
          </div>
          <div class="col-md-6" v-if="index === 0 && showMinimumPremiumField">
            <div class="row">
              <div class="col" style="flex: 1">
                <label>
                  {{ $t('Minimum Premium') }} <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col" style="flex: 1">
                <currency-input-widget :label="false" :model="model" attribute="minimum_premium"/>
              </div>
            </div>
          </div>
          <div class="col-md-6" v-if="index > 0">
            <div class="row">
              <div class="col" style="flex: 1">
                <label>
                  {{ $t('Over') }} <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col" style="flex: 1">
                <currency-input-widget :label="false" :model="premium" attribute="amount_over"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-1 text-left" v-if="index > 0 || (model.premiums.length === 1 && enableFirstTierRemoval)">
        <b-tooltip :target="`remove-premium-button-${index}`" :title="$t('Delete')"/>
        <font-awesome-icon class="text-danger hover-cursor"
                           :id="`remove-premium-button-${index}`"
                           @click="removePremiumByIndex(index)"
                           style="font-size: 1.5em;margin-top: .2em"
                           :icon="'times'"/>
      </div>
    </div>
  </div>
</template>

<script>
  import PercentageInputWidget from "../../widgets/PercentageInputWidget";
  import CurrencyInputWidget from "../../widgets/CurrencyInputWidget";
  import Premium from "./Premium.model";

  export default {
    name: "PremiumTiers",
    components: {CurrencyInputWidget, PercentageInputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      enableFirstTierRemoval: {
        type: Boolean,
        default: false
      },
      showMinimumPremiumField: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      init() {
        this.model.premiums = this.model.premiums.map(data => new Premium(data));

        if (this.model.premiums.length === 0) {
          this.addNewPremium();
        }
      },
      addNewPremium() {
        this.model.premiums.push(new Premium({amount_over: null, percent: ''}));
      },
      removePremiumByIndex(index) {
        for (let i = 0; i < this.model.premiums.length; i++) {
          if (i === index) {
            this.model.premiums.splice(i, 1);
            break;
          }
        }

        if (index === 0) {
          this.model.minimum_premium = 0;
        }
      },
    },
    watch: {
      'model'() {
        if (this.model && this.model.premiums) {
          this.init();
        }
      }
    }
  }
</script>

<style scoped>
</style>
